export enum PersonaSize {
  small = 'small',
  extraSmall = 'extra-small',
  medium = 'medium',
  large = 'large',
  extraLarge = 'extra-large',
  huge = 'huge',
}
